import { Address } from '@dreryk/address-common-api';

import { addressFormatter } from '@dreryk/react-common';
import { StyledMaxWidth } from '@dreryk/react-components';

import { StyledVisitLocationAddress } from './VisitLocationAddress.styled';

type VisitLocationDropdownItemContentProps = {
   readonly label: string | undefined;
   readonly address: Address;
};

export const VisitLocationDropdownItemContent = (props: VisitLocationDropdownItemContentProps): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={620}>
         {props.label}
         <StyledVisitLocationAddress>{addressFormatter(props.address)}</StyledVisitLocationAddress>
      </StyledMaxWidth>
   );
};
